import { PhSparkle } from 'ember-phosphor-icons';
import Component from '@glimmer/component';
import { DrawerHeader, DrawerBody } from 'tio-ui/components/drawer';
import type { TasApplicationExtension as TasApplicationModel } from 'tio-data/data/resources/tas-application.ext';
import type { AiRecommendationExtension as AiRecommendationModel } from 'tio-data/data/resources/ai-recommendation.ext';
import ApplicationAnalysisView from './ai-analysis/application-analysis-view.gts';

/**
 * AI Analysis drawer content component
 * Displays AI-generated recommendations and analysis for applications
 */
export interface AiAnalysisDrawerSignature {
  Args: {
    application: TasApplicationModel;
    recommendations?: AiRecommendationModel[];
  };
}

class AiAnalysisDrawer extends Component<AiAnalysisDrawerSignature> {
  get latestRecommendation(): AiRecommendationModel | null {
    const recommendations = this.args.recommendations;
    if (!recommendations || recommendations.length === 0) {
      return null;
    }
    // Return the most recent recommendation
    const sorted = [...recommendations].sort(
      (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
    );
    return sorted[0] || null;
  }

  get hasRecommendations(): boolean {
    return this.latestRecommendation !== null;
  }

  <template>
    <DrawerHeader>
      <div class="tio-row-between w-full">
        <div class="tio-row-snug">
          <PhSparkle @size="20" class="tio-fg-brand" />
          <h2 class="tio-text-heading tio-fg-primary">
            {{!-- {{t "tuition_assistance.application_approval.ai_analysis"}} --}}
            Ai Details
          </h2>
        </div>
      </div>
    </DrawerHeader>

    <DrawerBody>
      <div>
        {{#if this.hasRecommendations}}
          {{#let this.latestRecommendation as |recommendation|}}
            {{#if recommendation}}
              <ApplicationAnalysisView
                @recommendation={{recommendation}}
                @application={{@application}}
              />
            {{/if}}
          {{/let}}
        {{else}}
          {{! Empty State }}
          <div class="p-6 text-center">
            <PhSparkle @size="48" class="tio-fg-disabled mx-auto mb-4" />
            <h3 class="tio-text-base-semibold mb-2 tio-fg-primary">No AI Analysis Available</h3>
            <p class="text-sm tio-fg-secondary">
              AI analysis has not been generated for this application yet.
            </p>
          </div>
        {{/if}}
      </div>
    </DrawerBody>
  </template>
}

export default AiAnalysisDrawer;
